import React, { memo, useCallback } from 'react';

interface SearchBarProps {
  onSearch: (query: string) => void;
  loading: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = memo(({ onSearch, loading }) => {
  const [query, setQuery] = React.useState('');

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (query.trim()) {
        onSearch(query);
      }
    },
    [query, onSearch]
  );

  return (
    <form className="max-w-2xl mx-auto mb-12" onSubmit={handleSubmit}>
      <div className="relative group">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <svg className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
          </svg>
        </div>
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search businesses (e.g. 'Coffee in Seattle')"
          required
          disabled={loading}
          className="block w-full pl-12 pr-32 py-4 bg-white border border-gray-100 rounded-full text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500/50 shadow-sm hover:shadow-md transition-all duration-300 disabled:opacity-60"
        />
        <div className="absolute inset-y-2 right-2">
          <button 
            type="submit" 
            disabled={loading} 
            className="h-full px-6 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-full shadow-sm transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed hover:shadow-lg hover:shadow-blue-500/30"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            ) : (
              'Search'
            )}
          </button>
        </div>
      </div>
    </form>
  );
});

SearchBar.displayName = 'SearchBar';
